import type { InputHTMLAttributes, LegacyRef } from 'react'

import clsx from 'clsx'

import css from './Checkbox.module.scss'

export const Checkbox = ({
	className,
	refAsProp,
	...props
}: InputHTMLAttributes<HTMLInputElement> & {
	refAsProp?: LegacyRef<HTMLInputElement>
}) => (
	<input
		className={clsx(className, css.input)}
		ref={refAsProp}
		type='checkbox'
		{...props}
	/>
)
